import HerdPrimaryImage from './HerdPrimaryIcon.svg'
export const HerdPrimaryIcon = HerdPrimaryImage
